var processor = { exports: {} };
export {
  processor as __module
};
//# sourceMappingURL=processor.js.map
